// @ts-nocheck
import { useEffect } from 'react';
import { observer } from 'mobx-react';
import { CountryIcon, Input } from '@gamesb42/ui-kit';

import ConfirmModal, { InfoBlock } from 'components/ConfirmModal';
import Drawer from 'pages/Connection/components/Drawer';
import ConnectAccount from 'pages/Connection/components/ConnectAccount';
import AboutCompany, { about } from 'pages/Connection/components/AboutCompany';
import ContactPerson from 'pages/Connection/components/ContactPerson';
import CorporateDocument from 'pages/Connection/components/CorporateDocument';
import UBODirectors from 'pages/Connection/components/Director';
import AppInfo, { appInfoInst } from 'pages/Connection/components/AppInfo';
import CompanySignatory from 'pages/Connection/components/CompanySignatory';
import InfoScreen from 'pages/Connection/components/InfoScreen';
import ChooseRevenue from 'pages/Connection/components/ChooseRevenue';
import CorporateDocsConfirmModal from 'pages/Connection/components/CorporateDocsConfirmModal';
import DirectorsConfirmModal from 'pages/Connection/components/DirectorsConfirmModal';
import AppInfoConfirmModal from 'pages/Connection/components/AppInfoConfirmModal';
import TextArea from 'components/TextArea';
import CheckBox from 'components/CheckBox';
import ConfirmModalDirector from 'components/ConfirmModalDirector';

import connectionStore, {
  DrawerScreens,
} from 'pages/Connection/components/connectionStore';
import countries from 'pages/Connection/components/CountrySelect/countrieslist';
import appStore from 'store/App';
import userStore from 'store/User';
import { director } from 'pages/Connection/components/Director';
import { capitalizeFirstLetter } from 'utils/helpers';

import { ReactComponent as FileIcon } from 'pages/Connection/assets/file.svg';
import { ReactComponent as PdfIcon } from 'pages/Connection/assets/pdf.svg';
import { ReactComponent as PngIcon } from 'pages/Connection/assets/png.svg';
import { ReactComponent as JpegIcon } from 'pages/Connection/assets/jpeg.svg';
import { ReactComponent as GifIcon } from 'pages/Connection/assets/gif.svg';
import { ReactComponent as DocIcon } from 'pages/Connection/assets/doc.svg';
import { ReactComponent as DocxIcon } from 'pages/Connection/assets/docx.svg';
import { ReactComponent as XlsIcon } from 'pages/Connection/assets/xls.svg';
import { ReactComponent as XlsxIcon } from 'pages/Connection/assets/xlsx.svg';
import { ReactComponent as DjvuIcon } from 'pages/Connection/assets/djvu.svg';

import st from 'pages/Connection/components/CorporateDocument/styles.module.scss';
import s from './styles.module.scss';

interface InfoDrawerProps {
  initialScreen?: DrawerScreens;
}

export const InfoDrawer = observer(({ initialScreen }: InfoDrawerProps) => {
  useEffect(() => {
    if (initialScreen) {
      connectionStore.currentScreen = initialScreen;
    }
  }, [initialScreen]);

  const country = countries.find(
    (item) => item.code === about.address.country?.code,
  );
  const Country =
    (country && CountryIcon?.[country.code]) || CountryIcon.UNKNOWN;

  const getScreen = () => {
    switch (connectionStore.currentScreen) {
      case 'personInfo':
        return <ContactPerson />;
      case 'corporateDocs':
        return <CorporateDocument />;
      case 'directors':
        return <UBODirectors />;
      case 'appInfo':
        return <AppInfo />;
      case 'companySignatory':
        return <CompanySignatory />;
      case 'aboutCompany':
        return <AboutCompany />;
      case 'infoScreen':
        return <InfoScreen />;
      case 'revenuesList':
        return <ChooseRevenue />;
      case 'connectAccount':
      default:
        return <ConnectAccount />;
    }
  };

  const cutLongName = (name: string, length: number): string => {
    if (name.length > length) return name.substring(0, length - 1) + '...';

    return name;
  };

  const calcTypeIcon = (type: string) => {
    switch (type) {
      case 'image/png':
        return <PngIcon />;
      case 'application/pdf':
        return <PdfIcon />;
      case 'image/jpeg':
        return <JpegIcon />;
      case 'image/gif':
        return <GifIcon />;
      case 'application/msword':
        return <DocIcon />;
      case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
        return <DocxIcon />;
      case 'application/vnd.ms-excel':
        return <XlsIcon />;
      case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
        return <XlsxIcon />;
      case 'image/vnd.djvu':
        return <DjvuIcon />;
      default:
        return <FileIcon />;
    }
  };

  if (appStore.showAccountsDrawer) {
    const isIE = about.values.details.company_form === 'sole-proprietor';

    return (
      <Drawer initialScreen={initialScreen}>
        {getScreen()}

        {connectionStore.currentScreen !== 'corporateDocs' &&
          connectionStore.currentScreen !== 'appInfo' &&
          connectionStore.currentScreen !== 'directors' && (
            <ConfirmModal title="Please double-check your data before you submit">
              <InfoBlock
                title="Company information"
                content={[
                  {
                    leftContent: 'Company form',
                    rightContent:
                      about.values.details.company_form === 'sole-proprietor'
                        ? 'Individual Entrepreneur (IE)'
                        : capitalizeFirstLetter(
                            about.values.details.company_form || '',
                          ),
                  },
                  {
                    leftContent: isIE ? 'IE Full name' : 'Legal name',
                    rightContent: about.values.details.legal_name,
                  },
                  {
                    leftContent: isIE ? 'IE email' : 'Corporate email',
                    rightContent: about.values.details.email,
                  },
                  {
                    leftContent: isIE ? 'IE Phone number' : 'Phone number',
                    rightContent: about.values.details.phone,
                  },
                  {
                    leftContent: 'Web-site',
                    rightContent: about.values.details.website,
                  },
                ]}
              />
              <InfoBlock
                title={
                  isIE
                    ? 'Individual Entrepreneur full address (registrated)'
                    : 'Company full legal address'
                }
                content={[
                  {
                    leftContent: 'Country',
                    rightContent: country ? (
                      <div className={s.countryHolder}>
                        {Country && <Country className={s.icon} size={16} />}
                        {country.name}
                      </div>
                    ) : undefined,
                  },
                  {
                    leftContent: 'Postal/ZIP code',
                    rightContent: about.values.details.zip,
                  },
                  {
                    leftContent: 'State',
                    rightContent: about.values.details.state,
                  },
                  {
                    leftContent: 'City',
                    rightContent: about.values.details.city,
                  },
                  {
                    leftContent: 'Street Address',
                    rightContent: about.values.details.address,
                  },
                ]}
              />
              {isIE && (
                <InfoBlock
                  title="Individual Entrepreneur (IE) TAX number"
                  content={[
                    {
                      leftContent: 'TAX number (VAT/TIN/EIN/INN)',
                      rightContent: about.values.details.tax_number,
                    },
                  ]}
                />
              )}
              {!isIE && (
                <InfoBlock
                  title="Company registration and TAX number"
                  content={[
                    {
                      leftContent: 'Registration number',
                      rightContent: about.values.details.registration_number,
                    },
                    {
                      leftContent: 'TAX number (VAT/TIN/EIN/INN)',
                      rightContent: about.values.details.tax_number,
                    },
                  ]}
                />
              )}

              <InfoBlock
                title="Signer information"
                content={[
                  {
                    leftContent: 'Full name',
                    rightContent: about.signer?.full_name,
                  },
                  {
                    leftContent: 'Position',
                    rightContent: about.signer?.position,
                  },
                  {
                    leftContent: 'Email',
                    rightContent: about.signer?.email,
                  },
                ]}
              />
              {about.currency.includes('eur') && (
                <InfoBlock
                  title="EUR bank account"
                  content={[
                    {
                      leftContent: 'Bank name',
                      rightContent: about.eurBank?.bank_name,
                    },
                    {
                      leftContent: 'SWIFT code',
                      rightContent: about.eurBank?.swift,
                    },
                    {
                      leftContent: 'IBAN or account number',
                      rightContent: about.eurBank?.account,
                    },
                    {
                      leftContent: 'Bank address',
                      rightContent: about.eurBank?.bank_address,
                    },
                  ]}
                />
              )}

              {about.currency.includes('usd') && (
                <InfoBlock
                  title="USD bank account"
                  content={[
                    {
                      leftContent: 'Bank name',
                      rightContent: about.usdBank?.bank_name,
                    },
                    {
                      leftContent: 'SWIFT code',
                      rightContent: about.usdBank?.swift,
                    },
                    {
                      leftContent: 'IBAN or account number',
                      rightContent: about.usdBank?.account,
                    },
                    {
                      leftContent: 'Bank address',
                      rightContent: about.usdBank?.bank_address,
                    },
                    {
                      leftContent: 'Correspondent bank',
                      rightContent: about.usdBank?.correspondent_bank_name,
                    },
                    {
                      leftContent: 'Correspondent SWIFT code',
                      rightContent: about.usdBank?.correspondent_swift,
                    },
                    {
                      leftContent: 'Correspondent IBAN or account number',
                      rightContent: about.usdBank?.correspondent_account,
                    },
                    {
                      leftContent: 'Special instructions:',
                      rightContent: about.usdBank?.special_instructions,
                    },
                  ]}
                />
              )}
            </ConfirmModal>
          )}

        {connectionStore.currentScreen === 'corporateDocs' && (
          <CorporateDocsConfirmModal />
        )}

        {connectionStore.currentScreen === 'directors' && (
          <ConfirmModalDirector title="Please double-check your datа before you submit">
            {userStore.me?.company?.details?.company_form !== 'corporation' && (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  width: '100%',
                  // gap: "32px",
                }}
              >
                {/* 1 */}
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                  }}
                >
                  <div className={st.confirmBlock}>
                    <div className={st.row}>
                      <div style={{ width: '250px' }} className={st.cellleft}>
                        Proof of ID:
                      </div>
                      <div className={st.uploadedforConfirm}>
                        {director?.values?.profOfId?.name?.length! > 0 && (
                          <div
                            style={{ display: 'flex', alignItems: 'center' }}
                          >
                            {calcTypeIcon(
                              director?.values?.profOfId?.value?.type,
                            )}
                            <span className={st.confirmLink}>
                              {cutLongName(
                                director?.values?.profOfId?.name,
                                50,
                              )}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                {/* 2 */}
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                  }}
                >
                  <div className={st.confirmBlock}>
                    <div className={st.row}>
                      <div style={{ width: '250px' }} className={st.cellleft}>
                        Proof of Address:
                      </div>
                      <div className={st.uploadedforConfirm}>
                        {director?.values?.profOfAddress?.name?.length! > 0 && (
                          <div
                            style={{ display: 'flex', alignItems: 'center' }}
                          >
                            {calcTypeIcon(
                              director?.values?.profOfAddress?.value.type,
                            )}
                            <span className={st.confirmLink}>
                              {cutLongName(
                                director?.values?.profOfAddress?.name,
                                50,
                              )}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                {/* 3 */}
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                  }}
                >
                  <div className={st.confirmBlock}>
                    <div className={st.row}>
                      <div style={{ width: '250px' }} className={st.cellleft}>
                        Proof of Funds:
                      </div>
                      <div className={st.uploadedforConfirm}>
                        {director?.values?.profOfFunds?.name?.length! > 0 && (
                          <div
                            style={{ display: 'flex', alignItems: 'center' }}
                          >
                            {calcTypeIcon(
                              director?.values?.profOfFunds?.value.type,
                            )}
                            <span className={st.confirmLink}>
                              {cutLongName(
                                director?.values?.profOfFunds?.name,
                                50,
                              )}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {userStore.me.company.details.company_form === 'corporation' && (
              <>
                {director.values.persons?.map((el) => {
                  let content = [
                    {
                      leftContent: 'Full name',
                      rightContent: `${el?.fullName}`,
                    },
                    {
                      leftContent: 'Position',
                      rightContent: `${el?.positionInCompany}`,
                    },
                  ];

                  if (el?.profOfId?.name.length > 0) {
                    content = [
                      ...content,
                      {
                        leftContent: 'Proof of ID',
                        rightContent: (
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                            }}
                          >
                            {calcTypeIcon(el?.profOfId?.value.type)}
                            <span className={st.textUploaded}>
                              {cutLongName(el?.profOfId?.name, 17)}
                            </span>
                          </div>
                        ),
                      },
                    ];
                  }

                  if (el?.profOfAddress?.name.length > 0) {
                    content = [
                      ...content,
                      {
                        leftContent: 'Proof of Address',
                        rightContent: (
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                            }}
                          >
                            {calcTypeIcon(el?.profOfAddress?.value.type)}
                            <span className={st.textUploaded}>
                              {cutLongName(el?.profOfAddress?.name, 17)}
                            </span>
                          </div>
                        ),
                      },
                    ];
                  }

                  if (el?.resume?.name.length > 0) {
                    content = [
                      ...content,
                      {
                        leftContent: 'Resume/CV',
                        rightContent: (
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                            }}
                          >
                            {calcTypeIcon(el?.resume?.value.type)}
                            <span className={st.textUploaded}>
                              {cutLongName(el?.resume?.name, 17)}
                            </span>
                          </div>
                        ),
                      },
                    ];
                  }

                  if (el?.profOfFunds?.name.length > 0) {
                    content = [
                      ...content,
                      {
                        leftContent: 'Proof of Funds',
                        rightContent: (
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                            }}
                          >
                            {calcTypeIcon(el?.profOfFunds?.value.type)}
                            <span className={st.textUploaded}>
                              {cutLongName(el?.profOfFunds?.name, 17)}
                            </span>
                          </div>
                        ),
                      },
                    ];
                  }

                  if (el?.businessControl) {
                    content = [
                      ...content,
                      {
                        leftContent: (
                          <span>
                            More than 10% shares
                            <br /> or exercises control
                            <br /> over the business?
                          </span>
                        ),
                        rightContent: 'yes',
                      },
                    ];
                  }

                  return (
                    <InfoBlock
                      title={el?.fullName}
                      content={content}
                      key={el?.fullName}
                    />
                  );
                })}
              </>
            )}
          </ConfirmModalDirector>
        )}

        {connectionStore.currentScreen === 'appInfo' && (
          <AppInfoConfirmModal title="Please double-check your datа before you submit">
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                gap: '32px',
              }}
            >
              {/* 1 */}
              <h3>
                <b>Where is your app or game distributed now?*</b>
              </h3>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '32px',
                }}
              >
                <CheckBox
                  label="Apple App Store"
                  onChange={() =>
                    (appInfoInst.values.distribution.appleStore =
                      !appInfoInst.values.distribution.appleStore)
                  }
                  checked={appInfoInst.values.distribution.appleStore}
                />
                {appInfoInst.values.distribution.appleStore && (
                  <TextArea
                    value={appInfoInst.values.distribution.appleStoreComment}
                    label="Link to your game/app at Apple App Store*"
                    onChange={(value) => {
                      appInfoInst.values.distribution.appleStoreComment = value;
                    }}
                  />
                )}

                <CheckBox
                  label="Google Play"
                  onChange={() =>
                    (appInfoInst.values.distribution.googleStore =
                      !appInfoInst.values.distribution.googleStore)
                  }
                  checked={appInfoInst.values.distribution.googleStore}
                />
                {appInfoInst.values.distribution.googleStore && (
                  <TextArea
                    value={appInfoInst.values.distribution.googleStoreComment}
                    label="Link to your game/app at Google Play*"
                    onChange={(value) => {
                      appInfoInst.values.distribution.googleStoreComment =
                        value;
                    }}
                  />
                )}

                <CheckBox
                  label="Steam"
                  onChange={() =>
                    (appInfoInst.values.distribution.steam =
                      !appInfoInst.values.distribution.steam)
                  }
                  checked={appInfoInst.values.distribution.steam}
                />
                {appInfoInst.values.distribution.steam && (
                  <TextArea
                    value={appInfoInst.values.distribution.steamComment}
                    label="Link to your game/app at Steam*"
                    onChange={(value) => {
                      appInfoInst.values.distribution.steamComment = value;
                    }}
                  />
                )}

                <CheckBox
                  label="Other"
                  onChange={() =>
                    (appInfoInst.values.distribution.other =
                      !appInfoInst.values.distribution.other)
                  }
                  checked={appInfoInst.values.distribution.other}
                />
                {appInfoInst.values.distribution.other && (
                  <TextArea
                    value={appInfoInst.values.distribution.otherComment}
                    label="Enter your distribution platform"
                    onChange={(value) => {
                      appInfoInst.values.distribution.otherComment = value;
                    }}
                  />
                )}
              </div>

              {/* 2 */}
              <h3>
                <b>Monetization model of your app/game?*</b>
              </h3>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '32px',
                }}
              >
                <CheckBox
                  checked={
                    appInfoInst.values.monetization === 'In-app purchase'
                  }
                  type="round"
                  label="In-app purchase"
                  onChange={() => {
                    appInfoInst.values.monetization = 'In-app purchase';
                  }}
                />
                <CheckBox
                  checked={appInfoInst.values.monetization === 'Ads'}
                  type="round"
                  label="Ads"
                  onChange={() => {
                    appInfoInst.values.monetization = 'Ads';
                  }}
                />
                <CheckBox
                  checked={
                    appInfoInst.values.monetization === 'In-app purchase & Ads'
                  }
                  type="round"
                  label="In-app purchase & Ads"
                  onChange={() => {
                    appInfoInst.values.monetization = 'In-app purchase & Ads';
                  }}
                />
                <CheckBox
                  checked={appInfoInst.values.monetization === 'Premium'}
                  type="round"
                  label="Premium"
                  onChange={() => {
                    appInfoInst.values.monetization = 'Premium';
                  }}
                />
                <CheckBox
                  checked={appInfoInst.values.monetization === 'Subscription'}
                  type="round"
                  label="Subscription"
                  onChange={() => {
                    appInfoInst.values.monetization = 'Subscription';
                  }}
                />
                <CheckBox
                  checked={appInfoInst.values.monetization === "I don't know"}
                  type="round"
                  label="I don't know"
                  onChange={() => {
                    appInfoInst.values.monetization = "I don't know";
                  }}
                />
                <CheckBox
                  checked={appInfoInst.values.monetization === 'Other'}
                  type="round"
                  label="Other"
                  onChange={() => {
                    appInfoInst.values.monetization = 'Other';
                  }}
                />
              </div>

              {/* 3 */}
              <h3>
                <b>UA spends sources*</b>
              </h3>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '32px',
                }}
              >
                <CheckBox
                  checked={appInfoInst.values.uaSpend.facebook}
                  onChange={() =>
                    (appInfoInst.values.uaSpend.facebook =
                      !appInfoInst.values.uaSpend.facebook)
                  }
                  label="Facebook"
                />
                <CheckBox
                  checked={appInfoInst.values.uaSpend.googleAds}
                  onChange={() =>
                    (appInfoInst.values.uaSpend.googleAds =
                      !appInfoInst.values.uaSpend.googleAds)
                  }
                  label="Google Ads"
                />
                <CheckBox
                  checked={appInfoInst.values.uaSpend.appleSearchAds}
                  onChange={() =>
                    (appInfoInst.values.uaSpend.appleSearchAds =
                      !appInfoInst.values.uaSpend.appleSearchAds)
                  }
                  label="Apple Search Ads"
                />
                <CheckBox
                  checked={appInfoInst.values.uaSpend.snapchat}
                  onChange={() =>
                    (appInfoInst.values.uaSpend.snapchat =
                      !appInfoInst.values.uaSpend.snapchat)
                  }
                  label="Snapchat"
                />
                <CheckBox
                  checked={appInfoInst.values.uaSpend.tikTok}
                  onChange={() =>
                    (appInfoInst.values.uaSpend.tikTok =
                      !appInfoInst.values.uaSpend.tikTok)
                  }
                  label="Tik Tok"
                />
                <CheckBox
                  checked={appInfoInst.values.uaSpend.unityAds}
                  onChange={() =>
                    (appInfoInst.values.uaSpend.unityAds =
                      !appInfoInst.values.uaSpend.unityAds)
                  }
                  label="UnityAds"
                />
                <CheckBox
                  checked={appInfoInst.values.uaSpend.dontKnow}
                  onChange={() =>
                    (appInfoInst.values.uaSpend.dontKnow =
                      !appInfoInst.values.uaSpend.dontKnow)
                  }
                  label="I don't know"
                />
                <CheckBox
                  checked={appInfoInst.values.uaSpend.other}
                  onChange={() =>
                    (appInfoInst.values.uaSpend.other =
                      !appInfoInst.values.uaSpend.other)
                  }
                  label="Other"
                />
              </div>

              {/* 4 */}
              <h3>
                <b>Your current MMP (tracking service)*</b>
              </h3>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '32px',
                }}
              >
                <CheckBox
                  label="Adjust"
                  onChange={() =>
                    (appInfoInst.values.mmp.adjust =
                      !appInfoInst.values.mmp.adjust)
                  }
                  checked={appInfoInst.values.mmp.adjust}
                />
                <CheckBox
                  onChange={() =>
                    (appInfoInst.values.mmp.appsflyer =
                      !appInfoInst.values.mmp.appsflyer)
                  }
                  checked={appInfoInst.values.mmp.appsflyer}
                  label="Appsflyer"
                />
                <CheckBox
                  onChange={() =>
                    (appInfoInst.values.mmp.tenjin =
                      !appInfoInst.values.mmp.tenjin)
                  }
                  checked={appInfoInst.values.mmp.tenjin}
                  label="Tenjin"
                />
                <CheckBox
                  onChange={() =>
                    (appInfoInst.values.mmp.kochava =
                      !appInfoInst.values.mmp.kochava)
                  }
                  checked={appInfoInst.values.mmp.kochava}
                  label="Kochava"
                />
                <CheckBox
                  onChange={() =>
                    (appInfoInst.values.mmp.branch =
                      !appInfoInst.values.mmp.branch)
                  }
                  checked={appInfoInst.values.mmp.branch}
                  label="Branch"
                />
                <CheckBox
                  onChange={() =>
                    (appInfoInst.values.mmp.firebase =
                      !appInfoInst.values.mmp.firebase)
                  }
                  checked={appInfoInst.values.mmp.firebase}
                  label="Firebase"
                />
                <CheckBox
                  onChange={() =>
                    (appInfoInst.values.mmp.dontKnow =
                      !appInfoInst.values.mmp.dontKnow)
                  }
                  checked={appInfoInst.values.mmp.dontKnow}
                  label="I don't know"
                />
                <CheckBox
                  onChange={() =>
                    (appInfoInst.values.mmp.other =
                      !appInfoInst.values.mmp.other)
                  }
                  checked={appInfoInst.values.mmp.other}
                  label="Other"
                />
              </div>

              {/* 5 */}
              <h3>
                <b>Additional info about the project</b>
              </h3>
              <Input.TextArea
                label="Comment"
                disabled={false}
                showCount={true}
                maxLength={400}
                value={appInfoInst.values.additionalInfo}
                onChange={(e) => {
                  appInfoInst.values.additionalInfo = e.target.value;
                }}
              />
            </div>
          </AppInfoConfirmModal>
        )}
      </Drawer>
    );
  }

  return null;
});

export default InfoDrawer;
